export default "__VITE_ASSET__BOLJylW2__"